import { Outlet, useLocation } from "react-router-dom";
import { motion } from "motion/react";
import Header from "./Header";
import Footer from "./Footer";
import StickyCta from "./StickyCta";
import { easeSoft } from "../lib/motion";

export default function Layout() {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pb-20 md:pb-0">
        <motion.div
          key={pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: easeSoft }}
        >
          <Outlet />
        </motion.div>
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}
